export default __webpack_public_path__ + "static/media/header.2cb9b14b.jpg";